import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatRating(rating: number): string {
  return rating.toLocaleString();
}

export function getRatingColor(rating: number): string {
  if (rating >= 2000) return 'text-purple-600';
  if (rating >= 1800) return 'text-red-600';
  if (rating >= 1600) return 'text-orange-600';
  if (rating >= 1400) return 'text-yellow-600';
  if (rating >= 1200) return 'text-green-600';
  return 'text-gray-600';
}

export function validateChessUsername(username: string): boolean {
  // Chess.com usernames are 3-20 characters, alphanumeric and underscores only
  const regex = /^[a-zA-Z0-9_]{3,20}$/;
  return regex.test(username);
}

export function getDomainFromEmail(email: string): string {
  return email.split('@')[1] || '';
}

export function isAllowedDomain(email: string): boolean {
  const allowedDomains = [
    'atomostech.com',
    'lambdaresearch.in',
    'miratsgroup.com',
    'mirats.in',
    'miratsinsights.com',
  ];
  const domain = getDomainFromEmail(email);
  return allowedDomains.includes(domain);
} 

// URL extraction and validation utilities
export const extractUrls = (text: string): string[] => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.match(urlRegex) || [];
};

export const isYouTubeUrl = (url: string): boolean => {
  const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+/;
  return youtubeRegex.test(url);
};

export const isVideoUrl = (url: string): boolean => {
  return isYouTubeUrl(url) || url.includes('vimeo.com') || url.includes('dailymotion.com');
};

export const isImageUrl = (url: string): boolean => {
  const imageExtensions = /\.(jpg|jpeg|png|gif|webp|svg)$/i;
  return imageExtensions.test(url);
};

export const getDomainFromUrl = (url: string): string => {
  try {
    const domain = new URL(url).hostname.replace('www.', '');
    return domain;
  } catch {
    return url;
  }
}; 